import { Injectable } from '@angular/core';

const iconList = [
	{
		nameSpace: '',
		list: [
			'filled/action/3d_rotation.svg',
			'filled/action/accessibility.svg',
			'filled/action/accessible.svg',
			'filled/action/account_balance.svg',
			'filled/action/account_balance_wallet.svg',
			'filled/action/account_box.svg',
			'filled/action/account_circle.svg',
			'filled/action/add_shopping_cart.svg',
			'filled/action/alarm.svg',
			'filled/action/alarm_add.svg',
			'filled/action/alarm_off.svg',
			'filled/action/alarm_on.svg',
			'filled/action/all_out.svg',
			'filled/action/android.svg',
			'filled/action/announcement.svg',
			'filled/action/aspect_ratio.svg',
			'filled/action/assessment.svg',
			'filled/action/assignment.svg',
			'filled/action/assignment_ind.svg',
			'filled/action/assignment_late.svg',
			'filled/action/assignment_return.svg',
			'filled/action/assignment_returned.svg',
			'filled/action/assignment_turned_in.svg',
			'filled/action/autorenew.svg',
			'filled/action/backup.svg',
			'filled/action/book.svg',
			'filled/action/bookmark.svg',
			'filled/action/bookmark_border.svg',
			'filled/action/bug_report.svg',
			'filled/action/build.svg',
			'filled/action/cached.svg',
			'filled/action/camera_enhance.svg',
			'filled/action/card_giftcard.svg',
			'filled/action/card_membership.svg',
			'filled/action/card_travel.svg',
			'filled/action/change_history.svg',
			'filled/action/check_circle.svg',
			'filled/action/chrome_reader_mode.svg',
			'filled/action/class.svg',
			'filled/action/code.svg',
			'filled/action/compare_arrows.svg',
			'filled/action/copyright.svg',
			'filled/action/credit_card.svg',
			'filled/action/dashboard.svg',
			'filled/action/date_range.svg',
			'filled/action/delete.svg',
			'filled/action/delete_forever.svg',
			'filled/action/delete_outline.svg',
			'filled/action/description.svg',
			'filled/action/dns.svg',
			'filled/action/done.svg',
			'filled/action/done_all.svg',
			'filled/action/donut_large.svg',
			'filled/action/donut_small.svg',
			'filled/action/eject.svg',
			'filled/action/euro_symbol.svg',
			'filled/action/event.svg',
			'filled/action/event_seat.svg',
			'filled/action/exit_to_app.svg',
			'filled/action/explore.svg',
			'filled/action/extension.svg',
			'filled/action/face.svg',
			'filled/action/favorite.svg',
			'filled/action/favorite_border.svg',
			'filled/action/feedback.svg',
			'filled/action/find_in_page.svg',
			'filled/action/find_replace.svg',
			'filled/action/fingerprint.svg',
			'filled/action/flight_land.svg',
			'filled/action/flight_takeoff.svg',
			'filled/action/flip_to_back.svg',
			'filled/action/flip_to_front.svg',
			'filled/action/gavel.svg',
			'filled/action/get_app.svg',
			'filled/action/gif.svg',
			'filled/action/grade.svg',
			'filled/action/group_work.svg',
			'filled/action/g_translate.svg',
			'filled/action/help.svg',
			'filled/action/help_outline.svg',
			'filled/action/highlight_off.svg',
			'filled/action/history.svg',
			'filled/action/home.svg',
			'filled/action/hourglass_empty.svg',
			'filled/action/hourglass_full.svg',
			'filled/action/http.svg',
			'filled/action/https.svg',
			'filled/action/important_devices.svg',
			'filled/action/info.svg',
			'filled/action/info_outline.svg',
			'filled/action/input.svg',
			'filled/action/invert_colors.svg',
			'filled/action/label.svg',
			'filled/action/label_outline.svg',
			'filled/action/language.svg',
			'filled/action/launch.svg',
			'filled/action/lightbulb_outline.svg',
			'filled/action/line_style.svg',
			'filled/action/line_weight.svg',
			'filled/action/list.svg',
			'filled/action/lock.svg',
			'filled/action/lock_open.svg',
			'filled/action/lock_outline.svg',
			'filled/action/loyalty.svg',
			'filled/action/markunread_mailbox.svg',
			'filled/action/motorcycle.svg',
			'filled/action/note_add.svg',
			'filled/action/offline_pin.svg',
			'filled/action/opacity.svg',
			'filled/action/open_in_browser.svg',
			'filled/action/open_in_new.svg',
			'filled/action/open_with.svg',
			'filled/action/pageview.svg',
			'filled/action/pan_tool.svg',
			'filled/action/payment.svg',
			'filled/action/perm_camera_m24px.svg',
			'filled/action/perm_contact_calendar.svg',
			'filled/action/perm_data_setting.svg',
			'filled/action/perm_device_information.svg',
			'filled/action/perm_identity.svg',
			'filled/action/perm_media.svg',
			'filled/action/perm_phone_msg.svg',
			'filled/action/perm_scan_wifi.svg',
			'filled/action/pets.svg',
			'filled/action/picture_in_picture.svg',
			'filled/action/picture_in_picture_alt.svg',
			'filled/action/play_for_work.svg',
			'filled/action/polymer.svg',
			'filled/action/power_settings_new.svg',
			'filled/action/pregnant_woman.svg',
			'filled/action/print.svg',
			'filled/action/query_builder.svg',
			'filled/action/question_answer.svg',
			'filled/action/receipt.svg',
			'filled/action/record_voice_over.svg',
			'filled/action/redeem.svg',
			'filled/action/remove_shopping_cart.svg',
			'filled/action/reorder.svg',
			'filled/action/report_problem.svg',
			'filled/action/restore.svg',
			'filled/action/restore_page.svg',
			'filled/action/room.svg',
			'filled/action/rounded_corner.svg',
			'filled/action/rowing.svg',
			'filled/action/schedule.svg',
			'filled/action/search.svg',
			'filled/action/settings.svg',
			'filled/action/settings_applications.svg',
			'filled/action/settings_backup_restore.svg',
			'filled/action/settings_bluetooth.svg',
			'filled/action/settings_brightness.svg',
			'filled/action/settings_cell.svg',
			'filled/action/settings_ethernet.svg',
			'filled/action/settings_input_antenna.svg',
			'filled/action/settings_input_component.svg',
			'filled/action/settings_input_composite.svg',
			'filled/action/settings_input_hdmi.svg',
			'filled/action/settings_input_svideo.svg',
			'filled/action/settings_overscan.svg',
			'filled/action/settings_phone.svg',
			'filled/action/settings_power.svg',
			'filled/action/settings_remote.svg',
			'filled/action/settings_voice.svg',
			'filled/action/shop.svg',
			'filled/action/shopping_basket.svg',
			'filled/action/shopping_cart.svg',
			'filled/action/shop_two.svg',
			'filled/action/speaker_notes.svg',
			'filled/action/speaker_notes_off.svg',
			'filled/action/spellcheck.svg',
			'filled/action/stars.svg',
			'filled/action/store.svg',
			'filled/action/subject.svg',
			'filled/action/supervisor_account.svg',
			'filled/action/swap_horiz.svg',
			'filled/action/swap_vert.svg',
			'filled/action/swap_vertical_circle.svg',
			'filled/action/system_update_alt.svg',
			'filled/action/tab.svg',
			'filled/action/tab_unselected.svg',
			'filled/action/theaters.svg',
			'filled/action/thumbs_up_down.svg',
			'filled/action/thumb_down.svg',
			'filled/action/thumb_up.svg',
			'filled/action/timeline.svg',
			'filled/action/toc.svg',
			'filled/action/today.svg',
			'filled/action/toll.svg',
			'filled/action/touch_app.svg',
			'filled/action/track_changes.svg',
			'filled/action/translate.svg',
			'filled/action/trending_down.svg',
			'filled/action/trending_flat.svg',
			'filled/action/trending_up.svg',
			'filled/action/turned_in.svg',
			'filled/action/turned_in_not.svg',
			'filled/action/update.svg',
			'filled/action/verified_user.svg',
			'filled/action/view_agenda.svg',
			'filled/action/view_array.svg',
			'filled/action/view_carousel.svg',
			'filled/action/view_column.svg',
			'filled/action/view_day.svg',
			'filled/action/view_headline.svg',
			'filled/action/view_list.svg',
			'filled/action/view_module.svg',
			'filled/action/view_quilt.svg',
			'filled/action/view_stream.svg',
			'filled/action/view_week.svg',
			'filled/action/visibility.svg',
			'filled/action/visibility_off.svg',
			'filled/action/watch_later.svg',
			'filled/action/work.svg',
			'filled/action/youtube_searched_for.svg',
			'filled/action/zoom_in.svg',
			'filled/action/zoom_out.svg',
			'filled/alert/add_alert.svg',
			'filled/alert/error.svg',
			'filled/alert/error_outline.svg',
			'filled/alert/warning.svg',
			'filled/av/add_to_queue.svg',
			'filled/av/airplay.svg',
			'filled/av/album.svg',
			'filled/av/art_track.svg',
			'filled/av/av_timer.svg',
			'filled/av/branding_watermark.svg',
			'filled/av/call_to_action.svg',
			'filled/av/closed_caption.svg',
			'filled/av/equalizer.svg',
			'filled/av/explicit.svg',
			'filled/av/fast_forward.svg',
			'filled/av/fast_rewind.svg',
			'filled/av/featured_play_list.svg',
			'filled/av/featured_video.svg',
			'filled/av/fiber_dvr.svg',
			'filled/av/fiber_manual_record.svg',
			'filled/av/fiber_new.svg',
			'filled/av/fiber_pin.svg',
			'filled/av/fiber_smart_record.svg',
			'filled/av/forward_10.svg',
			'filled/av/forward_30.svg',
			'filled/av/forward_5.svg',
			'filled/av/games.svg',
			'filled/av/hd.svg',
			'filled/av/hearing.svg',
			'filled/av/high_quality.svg',
			'filled/av/library_add.svg',
			'filled/av/library_books.svg',
			'filled/av/library_mus24px.svg',
			'filled/av/loop.svg',
			'filled/av/m24px.svg',
			'filled/av/mnone.svg',
			'filled/av/moff.svg',
			'filled/av/movie.svg',
			'filled/av/musvideo.svg',
			'filled/av/new_releases.svg',
			'filled/av/note.svg',
			'filled/av/not_interested.svg',
			'filled/av/pause.svg',
			'filled/av/pause_circle_filled.svg',
			'filled/av/pause_circle_outline.svg',
			'filled/av/playlist_add.svg',
			'filled/av/playlist_add_check.svg',
			'filled/av/playlist_play.svg',
			'filled/av/play_arrow.svg',
			'filled/av/play_circle_filled.svg',
			'filled/av/play_circle_outline.svg',
			'filled/av/queue.svg',
			'filled/av/queue_mus24px.svg',
			'filled/av/queue_play_next.svg',
			'filled/av/radio.svg',
			'filled/av/recent_actors.svg',
			'filled/av/remove_from_queue.svg',
			'filled/av/repeat.svg',
			'filled/av/repeat_one.svg',
			'filled/av/replay.svg',
			'filled/av/replay_10.svg',
			'filled/av/replay_30.svg',
			'filled/av/replay_5.svg',
			'filled/av/shuffle.svg',
			'filled/av/skip_next.svg',
			'filled/av/skip_previous.svg',
			'filled/av/slow_motion_video.svg',
			'filled/av/snooze.svg',
			'filled/av/sort_by_alpha.svg',
			'filled/av/stop.svg',
			'filled/av/subscriptions.svg',
			'filled/av/subtitles.svg',
			'filled/av/surround_sound.svg',
			'filled/av/videocam.svg',
			'filled/av/videocam_off.svg',
			'filled/av/video_call.svg',
			'filled/av/video_label.svg',
			'filled/av/video_library.svg',
			'filled/av/volume_down.svg',
			'filled/av/volume_mute.svg',
			'filled/av/volume_off.svg',
			'filled/av/volume_up.svg',
			'filled/av/web.svg',
			'filled/av/web_asset.svg',
			'filled/communication/business.svg',
			'filled/communication/call.svg',
			'filled/communication/call_end.svg',
			'filled/communication/call_made.svg',
			'filled/communication/call_merge.svg',
			'filled/communication/call_missed.svg',
			'filled/communication/call_missed_outgoing.svg',
			'filled/communication/call_received.svg',
			'filled/communication/call_split.svg',
			'filled/communication/chat.svg',
			'filled/communication/chat_bubble.svg',
			'filled/communication/chat_bubble_outline.svg',
			'filled/communication/clear_all.svg',
			'filled/communication/comment.svg',
			'filled/communication/contacts.svg',
			'filled/communication/contact_mail.svg',
			'filled/communication/contact_phone.svg',
			'filled/communication/dialer_sip.svg',
			'filled/communication/dialpad.svg',
			'filled/communication/email.svg',
			'filled/communication/forum.svg',
			'filled/communication/import_contacts.svg',
			'filled/communication/import_export.svg',
			'filled/communication/invert_colors_off.svg',
			'filled/communication/live_help.svg',
			'filled/communication/location_off.svg',
			'filled/communication/location_on.svg',
			'filled/communication/mail_outline.svg',
			'filled/communication/message.svg',
			'filled/communication/no_sim.svg',
			'filled/communication/phone.svg',
			'filled/communication/phonelink_erase.svg',
			'filled/communication/phonelink_lock.svg',
			'filled/communication/phonelink_ring.svg',
			'filled/communication/phonelink_setup.svg',
			'filled/communication/portable_wifi_off.svg',
			'filled/communication/present_to_all.svg',
			'filled/communication/ring_volume.svg',
			'filled/communication/rss_feed.svg',
			'filled/communication/screen_share.svg',
			'filled/communication/speaker_phone.svg',
			'filled/communication/stay_current_landscape.svg',
			'filled/communication/stay_current_portrait.svg',
			'filled/communication/stay_primary_landscape.svg',
			'filled/communication/stay_primary_portrait.svg',
			'filled/communication/stop_screen_share.svg',
			'filled/communication/swap_calls.svg',
			'filled/communication/textsms.svg',
			'filled/communication/voicemail.svg',
			'filled/communication/vpn_key.svg',
			'filled/content/add.svg',
			'filled/content/add_box.svg',
			'filled/content/add_circle.svg',
			'filled/content/add_circle_outline.svg',
			'filled/content/archive.svg',
			'filled/content/backspace.svg',
			'filled/content/block.svg',
			'filled/content/clear.svg',
			'filled/content/content_copy.svg',
			'filled/content/content_cut.svg',
			'filled/content/content_paste.svg',
			'filled/content/create.svg',
			'filled/content/delete_sweep.svg',
			'filled/content/drafts.svg',
			'filled/content/filter_list.svg',
			'filled/content/flag.svg',
			'filled/content/font_download.svg',
			'filled/content/forward.svg',
			'filled/content/gesture.svg',
			'filled/content/inbox.svg',
			'filled/content/link.svg',
			'filled/content/low_priority.svg',
			'filled/content/mail.svg',
			'filled/content/markunread.svg',
			'filled/content/move_to_inbox.svg',
			'filled/content/next_week.svg',
			'filled/content/redo.svg',
			'filled/content/remove.svg',
			'filled/content/remove_circle.svg',
			'filled/content/remove_circle_outline.svg',
			'filled/content/reply.svg',
			'filled/content/reply_all.svg',
			'filled/content/report.svg',
			'filled/content/save.svg',
			'filled/content/save_alt.svg',
			'filled/content/select_all.svg',
			'filled/content/send.svg',
			'filled/content/sort.svg',
			'filled/content/text_format.svg',
			'filled/content/unarchive.svg',
			'filled/content/undo.svg',
			'filled/content/weekend.svg',
			'filled/device/access_alarm.svg',
			'filled/device/access_alarms.svg',
			'filled/device/access_time.svg',
			'filled/device/add_alarm.svg',
			'filled/device/airplanemode_active.svg',
			'filled/device/airplanemode_inactive.svg',
			'filled/device/battery_20.svg',
			'filled/device/battery_30.svg',
			'filled/device/battery_50.svg',
			'filled/device/battery_60.svg',
			'filled/device/battery_80.svg',
			'filled/device/battery_90.svg',
			'filled/device/battery_alert.svg',
			'filled/device/battery_charging_20.svg',
			'filled/device/battery_charging_30.svg',
			'filled/device/battery_charging_50.svg',
			'filled/device/battery_charging_60.svg',
			'filled/device/battery_charging_80.svg',
			'filled/device/battery_charging_90.svg',
			'filled/device/battery_charging_full.svg',
			'filled/device/battery_full.svg',
			'filled/device/battery_std.svg',
			'filled/device/battery_unknown.svg',
			'filled/device/bluetooth.svg',
			'filled/device/bluetooth_connected.svg',
			'filled/device/bluetooth_disabled.svg',
			'filled/device/bluetooth_searching.svg',
			'filled/device/brightness_auto.svg',
			'filled/device/brightness_high.svg',
			'filled/device/brightness_low.svg',
			'filled/device/brightness_medium.svg',
			'filled/device/data_usage.svg',
			'filled/device/developer_mode.svg',
			'filled/device/devices.svg',
			'filled/device/dvr.svg',
			'filled/device/gps_fixed.svg',
			'filled/device/gps_not_fixed.svg',
			'filled/device/gps_off.svg',
			'filled/device/grapheq.svg',
			'filled/device/location_disabled.svg',
			'filled/device/location_searching.svg',
			'filled/device/network_cell.svg',
			'filled/device/network_wifi.svg',
			'filled/device/nfc.svg',
			'filled/device/screen_lock_landscape.svg',
			'filled/device/screen_lock_portrait.svg',
			'filled/device/screen_lock_rotation.svg',
			'filled/device/screen_rotation.svg',
			'filled/device/sd_storage.svg',
			'filled/device/settings_system_daydream.svg',
			'filled/device/signal_cellular_0_bar.svg',
			'filled/device/signal_cellular_1_bar.svg',
			'filled/device/signal_cellular_2_bar.svg',
			'filled/device/signal_cellular_3_bar.svg',
			'filled/device/signal_cellular_4_bar.svg',
			'filled/device/signal_cellular_connected_no_internet_0_bar.svg',
			'filled/device/signal_cellular_connected_no_internet_1_bar.svg',
			'filled/device/signal_cellular_connected_no_internet_2_bar.svg',
			'filled/device/signal_cellular_connected_no_internet_3_bar.svg',
			'filled/device/signal_cellular_connected_no_internet_4_bar.svg',
			'filled/device/signal_cellular_no_sim.svg',
			'filled/device/signal_cellular_null.svg',
			'filled/device/signal_cellular_off.svg',
			'filled/device/signal_wifi_0_bar.svg',
			'filled/device/signal_wifi_1_bar.svg',
			'filled/device/signal_wifi_1_bar_lock.svg',
			'filled/device/signal_wifi_2_bar.svg',
			'filled/device/signal_wifi_2_bar_lock.svg',
			'filled/device/signal_wifi_3_bar.svg',
			'filled/device/signal_wifi_3_bar_lock.svg',
			'filled/device/signal_wifi_4_bar.svg',
			'filled/device/signal_wifi_4_bar_lock.svg',
			'filled/device/signal_wifi_off.svg',
			'filled/device/storage.svg',
			'filled/device/usb.svg',
			'filled/device/wallpaper.svg',
			'filled/device/widgets.svg',
			'filled/device/wifi_lock.svg',
			'filled/device/wifi_tethering.svg',
			'filled/editor/attach_file.svg',
			'filled/editor/attach_money.svg',
			'filled/editor/border_all.svg',
			'filled/editor/border_bottom.svg',
			'filled/editor/border_clear.svg',
			'filled/editor/border_color.svg',
			'filled/editor/border_horizontal.svg',
			'filled/editor/border_inner.svg',
			'filled/editor/border_left.svg',
			'filled/editor/border_outer.svg',
			'filled/editor/border_right.svg',
			'filled/editor/border_style.svg',
			'filled/editor/border_top.svg',
			'filled/editor/border_vertical.svg',
			'filled/editor/bubble_chart.svg',
			'filled/editor/drag_handle.svg',
			'filled/editor/format_align_center.svg',
			'filled/editor/format_align_justify.svg',
			'filled/editor/format_align_left.svg',
			'filled/editor/format_align_right.svg',
			'filled/editor/format_bold.svg',
			'filled/editor/format_clear.svg',
			'filled/editor/format_color_fill.svg',
			'filled/editor/format_color_reset.svg',
			'filled/editor/format_color_text.svg',
			'filled/editor/format_indent_decrease.svg',
			'filled/editor/format_indent_increase.svg',
			'filled/editor/format_ital24px.svg',
			'filled/editor/format_line_spacing.svg',
			'filled/editor/format_list_bulleted.svg',
			'filled/editor/format_list_numbered.svg',
			'filled/editor/format_paint.svg',
			'filled/editor/format_quote.svg',
			'filled/editor/format_shapes.svg',
			'filled/editor/format_size.svg',
			'filled/editor/format_strikethrough.svg',
			'filled/editor/format_textdirection_l_to_r.svg',
			'filled/editor/format_textdirection_r_to_l.svg',
			'filled/editor/format_underlined.svg',
			'filled/editor/functions.svg',
			'filled/editor/highlight.svg',
			'filled/editor/insert_chart.svg',
			'filled/editor/insert_comment.svg',
			'filled/editor/insert_drive_file.svg',
			'filled/editor/insert_emoticon.svg',
			'filled/editor/insert_invitation.svg',
			'filled/editor/insert_link.svg',
			'filled/editor/insert_photo.svg',
			'filled/editor/linear_scale.svg',
			'filled/editor/merge_type.svg',
			'filled/editor/mode_comment.svg',
			'filled/editor/mode_edit.svg',
			'filled/editor/monetization_on.svg',
			'filled/editor/money_off.svg',
			'filled/editor/multiline_chart.svg',
			'filled/editor/pie_chart.svg',
			'filled/editor/pie_chart_outlined.svg',
			'filled/editor/publish.svg',
			'filled/editor/short_text.svg',
			'filled/editor/show_chart.svg',
			'filled/editor/space_bar.svg',
			'filled/editor/strikethrough_s.svg',
			'filled/editor/text_fields.svg',
			'filled/editor/title.svg',
			'filled/editor/vertical_align_bottom.svg',
			'filled/editor/vertical_align_center.svg',
			'filled/editor/vertical_align_top.svg',
			'filled/editor/wrap_text.svg',
			'filled/fill/attachment.svg',
			'filled/fill/cloud.svg',
			'filled/fill/cloud_circle.svg',
			'filled/fill/cloud_done.svg',
			'filled/fill/cloud_download.svg',
			'filled/fill/cloud_off.svg',
			'filled/fill/cloud_queue.svg',
			'filled/fill/cloud_upload.svg',
			'filled/fill/create_new_folder.svg',
			'filled/fill/file_download.svg',
			'filled/fill/file_upload.svg',
			'filled/fill/folder.svg',
			'filled/fill/folder_open.svg',
			'filled/fill/folder_shared.svg',
			'filled/hardware/cast.svg',
			'filled/hardware/cast_connected.svg',
			'filled/hardware/computer.svg',
			'filled/hardware/desktop_mac.svg',
			'filled/hardware/desktop_windows.svg',
			'filled/hardware/developer_board.svg',
			'filled/hardware/devices_other.svg',
			'filled/hardware/device_hub.svg',
			'filled/hardware/dock.svg',
			'filled/hardware/gamepad.svg',
			'filled/hardware/headset.svg',
			'filled/hardware/headset_m24px.svg',
			'filled/hardware/keyboard.svg',
			'filled/hardware/keyboard_arrow_down.svg',
			'filled/hardware/keyboard_arrow_left.svg',
			'filled/hardware/keyboard_arrow_right.svg',
			'filled/hardware/keyboard_arrow_up.svg',
			'filled/hardware/keyboard_backspace.svg',
			'filled/hardware/keyboard_capslock.svg',
			'filled/hardware/keyboard_hide.svg',
			'filled/hardware/keyboard_return.svg',
			'filled/hardware/keyboard_tab.svg',
			'filled/hardware/keyboard_voice.svg',
			'filled/hardware/laptop.svg',
			'filled/hardware/laptop_chromebook.svg',
			'filled/hardware/laptop_mac.svg',
			'filled/hardware/laptop_windows.svg',
			'filled/hardware/memory.svg',
			'filled/hardware/mouse.svg',
			'filled/hardware/phonelink.svg',
			'filled/hardware/phonelink_off.svg',
			'filled/hardware/phone_android.svg',
			'filled/hardware/phone_iphone.svg',
			'filled/hardware/power_input.svg',
			'filled/hardware/router.svg',
			'filled/hardware/scanner.svg',
			'filled/hardware/security.svg',
			'filled/hardware/sim_card.svg',
			'filled/hardware/smartphone.svg',
			'filled/hardware/speaker.svg',
			'filled/hardware/speaker_group.svg',
			'filled/hardware/tablet.svg',
			'filled/hardware/tablet_android.svg',
			'filled/hardware/tablet_mac.svg',
			'filled/hardware/toys.svg',
			'filled/hardware/tv.svg',
			'filled/hardware/videogame_asset.svg',
			'filled/hardware/watch.svg',
			'filled/image/add_a_photo.svg',
			'filled/image/add_to_photos.svg',
			'filled/image/adjust.svg',
			'filled/image/assistant.svg',
			'filled/image/assistant_photo.svg',
			'filled/image/audiotrack.svg',
			'filled/image/blur_circular.svg',
			'filled/image/blur_linear.svg',
			'filled/image/blur_off.svg',
			'filled/image/blur_on.svg',
			'filled/image/brightness_1.svg',
			'filled/image/brightness_2.svg',
			'filled/image/brightness_3.svg',
			'filled/image/brightness_4.svg',
			'filled/image/brightness_5.svg',
			'filled/image/brightness_6.svg',
			'filled/image/brightness_7.svg',
			'filled/image/broken_image.svg',
			'filled/image/brush.svg',
			'filled/image/burst_mode.svg',
			'filled/image/camera.svg',
			'filled/image/camera_alt.svg',
			'filled/image/camera_front.svg',
			'filled/image/camera_rear.svg',
			'filled/image/camera_roll.svg',
			'filled/image/center_focus_strong.svg',
			'filled/image/center_focus_weak.svg',
			'filled/image/collections.svg',
			'filled/image/collections_bookmark.svg',
			'filled/image/colorize.svg',
			'filled/image/color_lens.svg',
			'filled/image/compare.svg',
			'filled/image/control_point.svg',
			'filled/image/control_point_duplicate.svg',
			'filled/image/crop.svg',
			'filled/image/crop_16_9.svg',
			'filled/image/crop_3_2.svg',
			'filled/image/crop_5_4.svg',
			'filled/image/crop_7_5.svg',
			'filled/image/crop_din.svg',
			'filled/image/crop_free.svg',
			'filled/image/crop_landscape.svg',
			'filled/image/crop_original.svg',
			'filled/image/crop_portrait.svg',
			'filled/image/crop_rotate.svg',
			'filled/image/crop_square.svg',
			'filled/image/dehaze.svg',
			'filled/image/details.svg',
			'filled/image/edit.svg',
			'filled/image/exposure.svg',
			'filled/image/exposure_neg_1.svg',
			'filled/image/exposure_neg_2.svg',
			'filled/image/exposure_plus_1.svg',
			'filled/image/exposure_plus_2.svg',
			'filled/image/exposure_zero.svg',
			'filled/image/filter.svg',
			'filled/image/filter_1.svg',
			'filled/image/filter_2.svg',
			'filled/image/filter_3.svg',
			'filled/image/filter_4.svg',
			'filled/image/filter_5.svg',
			'filled/image/filter_6.svg',
			'filled/image/filter_7.svg',
			'filled/image/filter_8.svg',
			'filled/image/filter_9.svg',
			'filled/image/filter_9_plus.svg',
			'filled/image/filter_b_and_w.svg',
			'filled/image/filter_center_focus.svg',
			'filled/image/filter_drama.svg',
			'filled/image/filter_frames.svg',
			'filled/image/filter_hdr.svg',
			'filled/image/filter_none.svg',
			'filled/image/filter_tilt_shift.svg',
			'filled/image/filter_vintage.svg',
			'filled/image/flare.svg',
			'filled/image/flash_auto.svg',
			'filled/image/flash_off.svg',
			'filled/image/flash_on.svg',
			'filled/image/flip.svg',
			'filled/image/gradient.svg',
			'filled/image/grain.svg',
			'filled/image/grid_off.svg',
			'filled/image/grid_on.svg',
			'filled/image/hdr_off.svg',
			'filled/image/hdr_on.svg',
			'filled/image/hdr_strong.svg',
			'filled/image/hdr_weak.svg',
			'filled/image/healing.svg',
			'filled/image/image.svg',
			'filled/image/image_aspect_ratio.svg',
			'filled/image/iso.svg',
			'filled/image/landscape.svg',
			'filled/image/leak_add.svg',
			'filled/image/leak_remove.svg',
			'filled/image/lens.svg',
			'filled/image/linked_camera.svg',
			'filled/image/looks.svg',
			'filled/image/looks_3.svg',
			'filled/image/looks_4.svg',
			'filled/image/looks_5.svg',
			'filled/image/looks_6.svg',
			'filled/image/looks_one.svg',
			'filled/image/looks_two.svg',
			'filled/image/loupe.svg',
			'filled/image/monochrome_photos.svg',
			'filled/image/movie_creation.svg',
			'filled/image/movie_filter.svg',
			'filled/image/musnote.svg',
			'filled/image/nature.svg',
			'filled/image/nature_people.svg',
			'filled/image/navigate_before.svg',
			'filled/image/navigate_next.svg',
			'filled/image/palette.svg',
			'filled/image/panorama.svg',
			'filled/image/panorama_fish_eye.svg',
			'filled/image/panorama_horizontal.svg',
			'filled/image/panorama_vertical.svg',
			'filled/image/panorama_wide_angle.svg',
			'filled/image/photo.svg',
			'filled/image/photo_album.svg',
			'filled/image/photo_camera.svg',
			'filled/image/photo_filter.svg',
			'filled/image/photo_library.svg',
			'filled/image/photo_size_select_actual.svg',
			'filled/image/photo_size_select_large.svg',
			'filled/image/photo_size_select_small.svg',
			'filled/image/picture_as_pdf.svg',
			'filled/image/portrait.svg',
			'filled/image/remove_red_eye.svg',
			'filled/image/rotate_90_degrees_ccw.svg',
			'filled/image/rotate_left.svg',
			'filled/image/rotate_right.svg',
			'filled/image/slideshow.svg',
			'filled/image/straighten.svg',
			'filled/image/style.svg',
			'filled/image/switch_camera.svg',
			'filled/image/switch_video.svg',
			'filled/image/tag_faces.svg',
			'filled/image/texture.svg',
			'filled/image/timelapse.svg',
			'filled/image/timer.svg',
			'filled/image/timer_10.svg',
			'filled/image/timer_3.svg',
			'filled/image/timer_off.svg',
			'filled/image/tonality.svg',
			'filled/image/transform.svg',
			'filled/image/tune.svg',
			'filled/image/view_comfy.svg',
			'filled/image/view_compact.svg',
			'filled/image/vignette.svg',
			'filled/image/wb_auto.svg',
			'filled/image/wb_cloudy.svg',
			'filled/image/wb_incandescent.svg',
			'filled/image/wb_iridescent.svg',
			'filled/image/wb_sunny.svg',
			'filled/maps/add_location.svg',
			'filled/maps/beenhere.svg',
			'filled/maps/directions.svg',
			'filled/maps/directions_bike.svg',
			'filled/maps/directions_boat.svg',
			'filled/maps/directions_bus.svg',
			'filled/maps/directions_car.svg',
			'filled/maps/directions_railway.svg',
			'filled/maps/directions_run.svg',
			'filled/maps/directions_subway.svg',
			'filled/maps/directions_transit.svg',
			'filled/maps/directions_walk.svg',
			'filled/maps/edit_location.svg',
			'filled/maps/ev_station.svg',
			'filled/maps/flight.svg',
			'filled/maps/hotel.svg',
			'filled/maps/layers.svg',
			'filled/maps/layers_clear.svg',
			'filled/maps/local_activity.svg',
			'filled/maps/local_airport.svg',
			'filled/maps/local_atm.svg',
			'filled/maps/local_bar.svg',
			'filled/maps/local_cafe.svg',
			'filled/maps/local_car_wash.svg',
			'filled/maps/local_convenience_store.svg',
			'filled/maps/local_dining.svg',
			'filled/maps/local_drink.svg',
			'filled/maps/local_florist.svg',
			'filled/maps/local_gas_station.svg',
			'filled/maps/local_grocery_store.svg',
			'filled/maps/local_hospital.svg',
			'filled/maps/local_hotel.svg',
			'filled/maps/local_laundry_service.svg',
			'filled/maps/local_library.svg',
			'filled/maps/local_mall.svg',
			'filled/maps/local_movies.svg',
			'filled/maps/local_offer.svg',
			'filled/maps/local_parking.svg',
			'filled/maps/local_pharmacy.svg',
			'filled/maps/local_phone.svg',
			'filled/maps/local_pizza.svg',
			'filled/maps/local_play.svg',
			'filled/maps/local_post_office.svg',
			'filled/maps/local_printshop.svg',
			'filled/maps/local_see.svg',
			'filled/maps/local_shipping.svg',
			'filled/maps/local_taxi.svg',
			'filled/maps/map.svg',
			'filled/maps/my_location.svg',
			'filled/maps/navigation.svg',
			'filled/maps/near_me.svg',
			'filled/maps/person_pin.svg',
			'filled/maps/person_pin_circle.svg',
			'filled/maps/pin_drop.svg',
			'filled/maps/place.svg',
			'filled/maps/rate_review.svg',
			'filled/maps/restaurant.svg',
			'filled/maps/restaurant_menu.svg',
			'filled/maps/satellite.svg',
			'filled/maps/store_mall_directory.svg',
			'filled/maps/streetview.svg',
			'filled/maps/subway.svg',
			'filled/maps/terrain.svg',
			'filled/maps/traffsvg.svg',
			'filled/maps/train.svg',
			'filled/maps/tram.svg',
			'filled/maps/transfer_within_a_station.svg',
			'filled/maps/zoom_out_map.svg',
			'filled/navigation/apps.svg',
			'filled/navigation/arrow_back.svg',
			'filled/navigation/arrow_downward.svg',
			'filled/navigation/arrow_drop_down.svg',
			'filled/navigation/arrow_drop_down_circle.svg',
			'filled/navigation/arrow_drop_up.svg',
			'filled/navigation/arrow_forward.svg',
			'filled/navigation/arrow_upward.svg',
			'filled/navigation/cancel.svg',
			'filled/navigation/check.svg',
			'filled/navigation/chevron_left.svg',
			'filled/navigation/chevron_right.svg',
			'filled/navigation/close.svg',
			'filled/navigation/expand_less.svg',
			'filled/navigation/expand_more.svg',
			'filled/navigation/first_page.svg',
			'filled/navigation/fullscreen.svg',
			'filled/navigation/fullscreen_exit.svg',
			'filled/navigation/last_page.svg',
			'filled/navigation/menu.svg',
			'filled/navigation/more_horiz.svg',
			'filled/navigation/more_vert.svg',
			'filled/navigation/refresh.svg',
			'filled/navigation/subdirectory_arrow_left.svg',
			'filled/navigation/subdirectory_arrow_right.svg',
			'filled/navigation/unfold_less.svg',
			'filled/navigation/unfold_more.svg',
			'filled/notification/adb.svg',
			'filled/notification/airline_seat_flat.svg',
			'filled/notification/airline_seat_flat_angled.svg',
			'filled/notification/airline_seat_individual_suite.svg',
			'filled/notification/airline_seat_legroom_extra.svg',
			'filled/notification/airline_seat_legroom_normal.svg',
			'filled/notification/airline_seat_legroom_reduced.svg',
			'filled/notification/airline_seat_recline_extra.svg',
			'filled/notification/airline_seat_recline_normal.svg',
			'filled/notification/bluetooth_audio.svg',
			'filled/notification/confirmation_number.svg',
			'filled/notification/disc_full.svg',
			'filled/notification/do_not_disturb.svg',
			'filled/notification/do_not_disturb_alt.svg',
			'filled/notification/do_not_disturb_off.svg',
			'filled/notification/do_not_disturb_on.svg',
			'filled/notification/drive_eta.svg',
			'filled/notification/enhanced_encryption.svg',
			'filled/notification/event_available.svg',
			'filled/notification/event_busy.svg',
			'filled/notification/event_note.svg',
			'filled/notification/folder_special.svg',
			'filled/notification/live_tv.svg',
			'filled/notification/mms.svg',
			'filled/notification/more.svg',
			'filled/notification/network_check.svg',
			'filled/notification/network_locked.svg',
			'filled/notification/no_encryption.svg',
			'filled/notification/ondemand_video.svg',
			'filled/notification/personal_video.svg',
			'filled/notification/phone_bluetooth_speaker.svg',
			'filled/notification/phone_forwarded.svg',
			'filled/notification/phone_in_talk.svg',
			'filled/notification/phone_locked.svg',
			'filled/notification/phone_missed.svg',
			'filled/notification/phone_paused.svg',
			'filled/notification/power.svg',
			'filled/notification/priority_high.svg',
			'filled/notification/rv_hookup.svg',
			'filled/notification/sd_card.svg',
			'filled/notification/sim_card_alert.svg',
			'filled/notification/sms.svg',
			'filled/notification/sms_failed.svg',
			'filled/notification/sync.svg',
			'filled/notification/sync_disabled.svg',
			'filled/notification/sync_problem.svg',
			'filled/notification/system_update.svg',
			'filled/notification/tap_and_play.svg',
			'filled/notification/time_to_leave.svg',
			'filled/notification/vibration.svg',
			'filled/notification/voice_chat.svg',
			'filled/notification/vpn_lock.svg',
			'filled/notification/wc.svg',
			'filled/notification/wifi.svg',
			'filled/places/ac_unit.svg',
			'filled/places/airport_shuttle.svg',
			'filled/places/all_inclusive.svg',
			'filled/places/beach_access.svg',
			'filled/places/business_center.svg',
			'filled/places/casino.svg',
			'filled/places/child_care.svg',
			'filled/places/child_friendly.svg',
			'filled/places/fitness_center.svg',
			'filled/places/free_breakfast.svg',
			'filled/places/golf_course.svg',
			'filled/places/hot_tub.svg',
			'filled/places/kitchen.svg',
			'filled/places/pool.svg',
			'filled/places/room_service.svg',
			'filled/places/rv_hookup.svg',
			'filled/places/smoke_free.svg',
			'filled/places/smoking_rooms.svg',
			'filled/places/spa.svg',
			'filled/social/cake.svg',
			'filled/social/domain.svg',
			'filled/social/group.svg',
			'filled/social/group_add.svg',
			'filled/social/location_city.svg',
			'filled/social/mood.svg',
			'filled/social/mood_bad.svg',
			'filled/social/notifications.svg',
			'filled/social/notifications_active.svg',
			'filled/social/notifications_none.svg',
			'filled/social/notifications_off.svg',
			'filled/social/notifications_paused.svg',
			'filled/social/pages.svg',
			'filled/social/party_mode.svg',
			'filled/social/people.svg',
			'filled/social/people_outline.svg',
			'filled/social/person.svg',
			'filled/social/person_add.svg',
			'filled/social/person_outline.svg',
			'filled/social/plus_one.svg',
			'filled/social/poll.svg',
			'filled/social/publ24px.svg',
			'filled/social/school.svg',
			'filled/social/sentiment_dissatisfied.svg',
			'filled/social/sentiment_neutral.svg',
			'filled/social/sentiment_satisfied.svg',
			'filled/social/sentiment_very_dissatisfied.svg',
			'filled/social/sentiment_very_satisfied.svg',
			'filled/social/share.svg',
			'filled/social/whatshot.svg',
			'filled/toggle/check_box.svg',
			'filled/toggle/check_box_outline_blank.svg',
			'filled/toggle/indeterminate_check_box.svg',
			'filled/toggle/radio_button_checked.svg',
			'filled/toggle/radio_button_unchecked.svg',
			'filled/toggle/star.svg',
			'filled/toggle/star_border.svg',
			'filled/toggle/star_half.svg'
		]
	},
	{
		nameSpace: 'outlined',
		list: [
			'outlined/action/3d_rotation.svg',
			'outlined/action/accessibility.svg',
			'outlined/action/accessibility_new.svg',
			'outlined/action/accessible.svg',
			'outlined/action/accessible_forward.svg',
			'outlined/action/account_balance.svg',
			'outlined/action/account_balance_wallet.svg',
			'outlined/action/account_box.svg',
			'outlined/action/account_circle.svg',
			'outlined/action/add_shopping_cart.svg',
			'outlined/action/alarm.svg',
			'outlined/action/alarm_add.svg',
			'outlined/action/alarm_off.svg',
			'outlined/action/alarm_on.svg',
			'outlined/action/all_inbox.svg',
			'outlined/action/all_out.svg',
			'outlined/action/announcement.svg',
			'outlined/action/arrow_right_alt.svg',
			'outlined/action/aspect_ratio.svg',
			'outlined/action/assessment.svg',
			'outlined/action/assignment.svg',
			'outlined/action/assignment_ind.svg',
			'outlined/action/assignment_late.svg',
			'outlined/action/assignment_return.svg',
			'outlined/action/assignment_returned.svg',
			'outlined/action/assignment_turned_in.svg',
			'outlined/action/autorenew.svg',
			'outlined/action/backup.svg',
			'outlined/action/book.svg',
			'outlined/action/bookmarks.svg',
			'outlined/action/bookmark_border.svg',
			'outlined/action/bug_report.svg',
			'outlined/action/build.svg',
			'outlined/action/cached.svg',
			'outlined/action/calendar_today.svg',
			'outlined/action/calendar_view_day.svg',
			'outlined/action/camera_enhance.svg',
			'outlined/action/card_giftcard.svg',
			'outlined/action/card_membership.svg',
			'outlined/action/card_travel.svg',
			'outlined/action/change_history.svg',
			'outlined/action/check_circle.svg',
			'outlined/action/check_circle_outline.svg',
			'outlined/action/chrome_reader_mode.svg',
			'outlined/action/class.svg',
			'outlined/action/code.svg',
			'outlined/action/commute.svg',
			'outlined/action/compare_arrows.svg',
			'outlined/action/contact_support.svg',
			'outlined/action/copyright.svg',
			'outlined/action/credit_card.svg',
			'outlined/action/dashboard.svg',
			'outlined/action/date_range.svg',
			'outlined/action/delete.svg',
			'outlined/action/delete_forever.svg',
			'outlined/action/delete_outline.svg',
			'outlined/action/description.svg',
			'outlined/action/dns.svg',
			'outlined/action/done.svg',
			'outlined/action/done_all.svg',
			'outlined/action/done_outline.svg',
			'outlined/action/donut_large.svg',
			'outlined/action/donut_small.svg',
			'outlined/action/drag_indicator.svg',
			'outlined/action/eject.svg',
			'outlined/action/euro_symbol.svg',
			'outlined/action/event.svg',
			'outlined/action/event_seat.svg',
			'outlined/action/exit_to_app.svg',
			'outlined/action/explore.svg',
			'outlined/action/explore_off (1).svg',
			'outlined/action/explore_off.svg',
			'outlined/action/extension (1).svg',
			'outlined/action/extension.svg',
			'outlined/action/face (1).svg',
			'outlined/action/face.svg',
			'outlined/action/favorite.svg',
			'outlined/action/favorite_border.svg',
			'outlined/action/flip_to_front.svg',
			'outlined/action/gavel.svg',
			'outlined/action/get_app.svg',
			'outlined/action/gif.svg',
			'outlined/action/grade.svg',
			'outlined/action/group_work.svg',
			'outlined/action/g_translate.svg',
			'outlined/action/help_outline.svg',
			'outlined/action/highlight_off.svg',
			'outlined/action/history.svg',
			'outlined/action/home.svg',
			'outlined/action/horizontal_split.svg',
			'outlined/action/hourglass_empty.svg',
			'outlined/action/hourglass_full.svg',
			'outlined/action/http.svg',
			'outlined/action/https.svg',
			'outlined/action/important_devices.svg',
			'outlined/action/info.svg',
			'outlined/action/input.svg',
			'outlined/action/invert_colors.svg',
			'outlined/action/label.svg',
			'outlined/action/label_important.svg',
			'outlined/action/label_off.svg',
			'outlined/action/language.svg',
			'outlined/action/note_add.svg',
			'outlined/action/offline_bolt.svg',
			'outlined/action/offline_pin.svg',
			'outlined/action/opacity.svg',
			'outlined/action/open_in_browser.svg',
			'outlined/action/open_in_new.svg',
			'outlined/action/open_with.svg',
			'outlined/action/pageview.svg',
			'outlined/action/pan_tool.svg',
			'outlined/action/payment.svg',
			'outlined/action/perm_camera_mic.svg',
			'outlined/action/perm_contact_calendar.svg',
			'outlined/action/perm_data_setting.svg',
			'outlined/action/perm_device_information.svg',
			'outlined/action/perm_identity.svg',
			'outlined/action/perm_media.svg',
			'outlined/action/perm_phone_msg.svg',
			'outlined/action/perm_scan_wifi.svg',
			'outlined/action/pets.svg',
			'outlined/action/picture_in_picture.svg',
			'outlined/action/picture_in_picture_alt.svg',
			'outlined/action/play_for_work.svg',
			'outlined/action/polymer.svg',
			'outlined/action/power_settings_new.svg',
			'outlined/action/pregnant_woman.svg',
			'outlined/action/print.svg',
			'outlined/action/query_builder.svg',
			'outlined/action/question_answer.svg',
			'outlined/action/receipt.svg',
			'outlined/action/record_voice_over.svg',
			'outlined/action/redeem.svg',
			'outlined/action/remove_shopping_cart.svg',
			'outlined/action/reorder.svg',
			'outlined/action/report_problem.svg',
			'outlined/action/restore.svg',
			'outlined/action/restore_from_trash.svg',
			'outlined/action/restore_page.svg',
			'outlined/action/room.svg',
			'outlined/action/rounded_corner.svg',
			'outlined/action/rowing.svg',
			'outlined/action/schedule.svg',
			'outlined/action/search.svg',
			'outlined/action/settings.svg',
			'outlined/action/settings_applications.svg',
			'outlined/action/settings_backup_restore.svg',
			'outlined/action/settings_bluetooth.svg',
			'outlined/action/settings_brightness.svg',
			'outlined/action/settings_cell.svg',
			'outlined/action/settings_ethernet.svg',
			'outlined/action/settings_input_antenna.svg',
			'outlined/action/settings_input_component.svg',
			'outlined/action/settings_input_composite.svg',
			'outlined/action/settings_input_hdmi.svg',
			'outlined/action/settings_input_svideo.svg',
			'outlined/action/settings_overscan.svg',
			'outlined/action/settings_phone.svg',
			'outlined/action/settings_power.svg',
			'outlined/action/settings_remote.svg',
			'outlined/action/settings_voice.svg',
			'outlined/action/shop.svg',
			'outlined/action/shopping_basket.svg',
			'outlined/action/shopping_cart.svg',
			'outlined/action/shop_two.svg',
			'outlined/action/speaker_notes.svg',
			'outlined/action/speaker_notes_off.svg',
			'outlined/action/spellcheck.svg',
			'outlined/action/stars.svg',
			'outlined/action/star_rate-18px.svg',
			'outlined/action/store.svg',
			'outlined/action/subject.svg',
			'outlined/action/supervised_user_circle.svg',
			'outlined/action/supervisor_account.svg',
			'outlined/action/swap_horiz.svg',
			'outlined/action/swap_horizontal_circle.svg',
			'outlined/action/swap_vert.svg',
			'outlined/action/swap_vertical_circle.svg',
			'outlined/action/tab.svg',
			'outlined/action/tab_unselected.svg',
			'outlined/action/text_rotate_up.svg',
			'outlined/action/text_rotate_vertical.svg',
			'outlined/action/text_rotation_down.svg',
			'outlined/action/text_rotation_none.svg',
			'outlined/action/theaters.svg',
			'outlined/action/thumbs_up_down.svg',
			'outlined/action/thumb_down.svg',
			'outlined/action/thumb_up.svg',
			'outlined/action/timeline.svg',
			'outlined/action/toc.svg',
			'outlined/action/today.svg',
			'outlined/action/toll.svg',
			'outlined/action/touch_app.svg',
			'outlined/action/track_changes.svg',
			'outlined/action/translate.svg',
			'outlined/action/trending_down.svg',
			'outlined/action/trending_flat.svg',
			'outlined/action/trending_up.svg',
			'outlined/action/turned_in.svg',
			'outlined/action/turned_in_not.svg',
			'outlined/action/update.svg',
			'outlined/action/verified_user.svg',
			'outlined/action/vertical_split.svg',
			'outlined/action/view_agenda.svg',
			'outlined/action/view_array.svg',
			'outlined/action/view_carousel.svg',
			'outlined/action/view_column.svg',
			'outlined/action/view_day.svg',
			'outlined/action/view_headline.svg',
			'outlined/action/view_list.svg',
			'outlined/action/view_module.svg',
			'outlined/action/view_quilt.svg',
			'outlined/action/view_stream.svg',
			'outlined/action/view_week.svg',
			'outlined/action/visibility.svg',
			'outlined/action/visibility_off.svg',
			'outlined/action/voice_over_off.svg',
			'outlined/action/watch_later.svg',
			'outlined/action/work.svg',
			'outlined/action/work_off.svg',
			'outlined/action/work_outline.svg',
			'outlined/action/youtube_searched_for.svg',
			'outlined/action/zoom_in.svg',
			'outlined/action/zoom_out.svg',
			'outlined/alert/add_alert.svg',
			'outlined/alert/error_outline.svg',
			'outlined/alert/notification_important.svg',
			'outlined/av/4k.svg',
			'outlined/av/add_to_queue.svg',
			'outlined/av/airplay.svg',
			'outlined/av/album.svg',
			'outlined/av/art_track.svg',
			'outlined/av/av_timer.svg',
			'outlined/av/branding_watermark.svg',
			'outlined/av/call_to_action.svg',
			'outlined/av/closed_caption.svg',
			'outlined/av/control_camera.svg',
			'outlined/av/equalizer.svg',
			'outlined/av/explicit.svg',
			'outlined/av/fast_forward.svg',
			'outlined/av/fast_rewind.svg',
			'outlined/av/featured_play_list.svg',
			'outlined/av/featured_video.svg',
			'outlined/av/fiber_dvr.svg',
			'outlined/av/fiber_manual_record.svg',
			'outlined/av/fiber_new.svg',
			'outlined/av/fiber_pin.svg',
			'outlined/av/fiber_smart_record.svg',
			'outlined/av/forward_10.svg',
			'outlined/av/forward_30.svg',
			'outlined/av/forward_5.svg',
			'outlined/av/games.svg',
			'outlined/av/hd.svg',
			'outlined/av/hearing.svg',
			'outlined/av/high_quality.svg',
			'outlined/av/library_add.svg',
			'outlined/av/library_books.svg',
			'outlined/av/library_music.svg',
			'outlined/av/loop.svg',
			'outlined/av/mic.svg',
			'outlined/av/mic_none.svg',
			'outlined/av/mic_off.svg',
			'outlined/av/missed_video_call.svg',
			'outlined/av/movie.svg',
			'outlined/av/music_video.svg',
			'outlined/av/new_releases.svg',
			'outlined/av/note.svg',
			'outlined/av/not_interested.svg',
			'outlined/av/pause.svg',
			'outlined/av/pause_circle_filled.svg',
			'outlined/av/pause_circle_outline.svg',
			'outlined/av/playlist_add.svg',
			'outlined/av/playlist_add_check.svg',
			'outlined/av/playlist_play.svg',
			'outlined/av/play_arrow.svg',
			'outlined/av/play_circle_filled.svg',
			'outlined/av/play_circle_filled_white.svg',
			'outlined/av/play_circle_outline.svg',
			'outlined/av/queue.svg',
			'outlined/av/queue_music.svg',
			'outlined/av/queue_play_next.svg',
			'outlined/av/radio.svg',
			'outlined/av/recent_actors.svg',
			'outlined/av/remove_from_queue.svg',
			'outlined/av/repeat.svg',
			'outlined/av/repeat_one.svg',
			'outlined/av/replay.svg',
			'outlined/av/replay_10.svg',
			'outlined/av/replay_30.svg',
			'outlined/av/replay_5.svg',
			'outlined/av/shuffle.svg',
			'outlined/av/skip_next.svg',
			'outlined/av/skip_previous.svg',
			'outlined/av/slow_motion_video.svg',
			'outlined/av/snooze.svg',
			'outlined/av/sort_by_alpha.svg',
			'outlined/av/stop.svg',
			'outlined/av/subscriptions.svg',
			'outlined/av/subtitles.svg',
			'outlined/av/surround_sound.svg',
			'outlined/av/videocam.svg',
			'outlined/av/videocam_off.svg',
			'outlined/av/video_call.svg',
			'outlined/av/video_label.svg',
			'outlined/av/video_library.svg',
			'outlined/av/volume_down.svg',
			'outlined/av/volume_mute.svg',
			'outlined/av/volume_off.svg',
			'outlined/av/volume_up.svg',
			'outlined/av/web.svg',
			'outlined/av/web_asset.svg',
			'outlined/communication/alternate_email.svg',
			'outlined/communication/business.svg',
			'outlined/communication/call.svg',
			'outlined/communication/call_end.svg',
			'outlined/communication/call_made.svg',
			'outlined/communication/call_merge.svg',
			'outlined/communication/call_missed.svg',
			'outlined/communication/call_missed_outgoing.svg',
			'outlined/communication/call_received.svg',
			'outlined/communication/call_split.svg',
			'outlined/communication/cancel_presentation.svg',
			'outlined/communication/cell_wifi.svg',
			'outlined/communication/chat.svg',
			'outlined/communication/chat_bubble.svg',
			'outlined/communication/chat_bubble_outline.svg',
			'outlined/communication/clear_all.svg',
			'outlined/communication/comment.svg',
			'outlined/communication/contacts.svg',
			'outlined/communication/contact_mail.svg',
			'outlined/communication/contact_phone.svg',
			'outlined/communication/desktop_access_disabled.svg',
			'outlined/communication/dialer_sip.svg',
			'outlined/communication/dialpad.svg',
			'outlined/communication/domain_disabled.svg',
			'outlined/communication/duo.svg',
			'outlined/communication/email.svg',
			'outlined/communication/forum.svg',
			'outlined/communication/import_contacts.svg',
			'outlined/communication/import_export.svg',
			'outlined/communication/invert_colors_off.svg',
			'outlined/communication/list_alt.svg',
			'outlined/communication/live_help.svg',
			'outlined/communication/location_off.svg',
			'outlined/communication/location_on.svg',
			'outlined/communication/mail_outline.svg',
			'outlined/communication/message.svg',
			'outlined/communication/mobile_screen_share.svg',
			'outlined/communication/no_sim.svg',
			'outlined/communication/pause_presentation.svg',
			'outlined/communication/person_add_disabled.svg',
			'outlined/communication/phone.svg',
			'outlined/communication/phonelink_erase.svg',
			'outlined/communication/phonelink_lock.svg',
			'outlined/communication/phonelink_ring.svg',
			'outlined/communication/phonelink_setup.svg',
			'outlined/communication/portable_wifi_off.svg',
			'outlined/communication/present_to_all.svg',
			'outlined/communication/print_disabled.svg',
			'outlined/communication/ring_volume.svg',
			'outlined/communication/rss_feed.svg',
			'outlined/communication/screen_share.svg',
			'outlined/communication/sentiment_satisfied_alt.svg',
			'outlined/communication/speaker_phone.svg',
			'outlined/communication/stay_current_landscape.svg',
			'outlined/communication/stay_current_portrait.svg',
			'outlined/communication/stay_primary_landscape.svg',
			'outlined/communication/stay_primary_portrait.svg',
			'outlined/communication/stop_screen_share.svg',
			'outlined/communication/swap_calls.svg',
			'outlined/communication/textsms.svg',
			'outlined/communication/unsubscribe.svg',
			'outlined/communication/voicemail.svg',
			'outlined/communication/vpn_key.svg',
			'outlined/content/add.svg',
			'outlined/content/add_box.svg',
			'outlined/content/add_circle.svg',
			'outlined/content/add_circle_outline.svg',
			'outlined/content/archive.svg',
			'outlined/content/backspace.svg',
			'outlined/content/ballot.svg',
			'outlined/content/block.svg',
			'outlined/content/clear.svg',
			'outlined/content/create.svg',
			'outlined/content/delete_sweep.svg',
			'outlined/content/drafts.svg',
			'outlined/content/file_copy.svg',
			'outlined/content/filter_list.svg',
			'outlined/content/flag.svg',
			'outlined/content/font_download.svg',
			'outlined/content/forward.svg',
			'outlined/content/gesture.svg',
			'outlined/content/how_to_reg.svg',
			'outlined/content/how_to_vote.svg',
			'outlined/content/inbox.svg',
			'outlined/content/link.svg',
			'outlined/content/link_off.svg',
			'outlined/content/low_priority.svg',
			'outlined/content/mail.svg',
			'outlined/content/markunread.svg',
			'outlined/content/move_to_inbox.svg',
			'outlined/content/next_week.svg',
			'outlined/content/outlined_flag.svg',
			'outlined/content/redo.svg',
			'outlined/content/remove.svg',
			'outlined/content/remove_circle.svg',
			'outlined/content/remove_circle_outline.svg',
			'outlined/content/reply.svg',
			'outlined/content/reply_all.svg',
			'outlined/content/report.svg',
			'outlined/content/report_off.svg',
			'outlined/content/save.svg',
			'outlined/content/save_alt.svg',
			'outlined/content/select_all.svg',
			'outlined/content/send.svg',
			'outlined/content/sort.svg',
			'outlined/content/text_format.svg',
			'outlined/content/unarchive.svg',
			'outlined/content/undo.svg',
			'outlined/content/waves.svg',
			'outlined/content/weekend.svg',
			'outlined/content/where_to_vote.svg',
			'outlined/device/access_alarm.svg',
			'outlined/device/access_alarms.svg',
			'outlined/device/access_time.svg',
			'outlined/device/add_alarm.svg',
			'outlined/device/add_to_home_screen.svg',
			'outlined/device/airplanemode_active.svg',
			'outlined/device/airplanemode_inactive.svg',
			'outlined/device/battery_20.svg',
			'outlined/device/battery_30.svg',
			'outlined/device/battery_50.svg',
			'outlined/device/battery_60.svg',
			'outlined/device/battery_80.svg',
			'outlined/device/battery_90.svg',
			'outlined/device/battery_alert.svg',
			'outlined/device/battery_charging_20.svg',
			'outlined/device/battery_charging_30.svg',
			'outlined/device/battery_charging_50.svg',
			'outlined/device/battery_charging_60.svg',
			'outlined/device/battery_charging_80.svg',
			'outlined/device/battery_charging_90.svg',
			'outlined/device/battery_charging_full.svg',
			'outlined/device/battery_full.svg',
			'outlined/device/battery_std.svg',
			'outlined/device/battery_unknown.svg',
			'outlined/device/bluetooth.svg',
			'outlined/device/bluetooth_connected.svg',
			'outlined/device/bluetooth_disabled.svg',
			'outlined/device/bluetooth_searching.svg',
			'outlined/device/brightness_auto.svg',
			'outlined/device/brightness_high.svg',
			'outlined/device/brightness_low.svg',
			'outlined/device/brightness_medium.svg',
			'outlined/device/data_usage.svg',
			'outlined/device/developer_mode.svg',
			'outlined/device/devices.svg',
			'outlined/device/dvr.svg',
			'outlined/device/gps_fixed.svg',
			'outlined/device/gps_not_fixed.svg',
			'outlined/device/gps_off.svg',
			'outlined/device/graphic_eq.svg',
			'outlined/device/location_disabled.svg',
			'outlined/device/location_searching.svg',
			'outlined/device/mobile_friendly.svg',
			'outlined/device/mobile_off.svg',
			'outlined/device/network_cell.svg',
			'outlined/device/network_wifi.svg',
			'outlined/device/nfc.svg',
			'outlined/device/screen_lock_landscape.svg',
			'outlined/device/screen_lock_portrait.svg',
			'outlined/device/screen_lock_rotation.svg',
			'outlined/device/screen_rotation.svg',
			'outlined/device/sd_storage.svg',
			'outlined/device/settings_system_daydream.svg',
			'outlined/device/signal_cellular_0_bar.svg',
			'outlined/device/signal_cellular_1_bar.svg',
			'outlined/device/signal_cellular_2_bar.svg',
			'outlined/device/signal_cellular_3_bar.svg',
			'outlined/device/signal_cellular_4_bar.svg',
			'outlined/device/signal_cellular_alt.svg',
			'outlined/device/signal_cellular_connected_no_internet_0_bar.svg',
			'outlined/device/signal_cellular_connected_no_internet_1_bar.svg',
			'outlined/device/signal_cellular_connected_no_internet_2_bar.svg',
			'outlined/device/signal_cellular_connected_no_internet_3_bar.svg',
			'outlined/device/signal_cellular_connected_no_internet_4_bar.svg',
			'outlined/device/signal_cellular_no_sim.svg',
			'outlined/device/signal_cellular_null.svg',
			'outlined/device/signal_cellular_off.svg',
			'outlined/device/signal_wifi_0_bar.svg',
			'outlined/device/signal_wifi_1_bar.svg',
			'outlined/device/signal_wifi_1_bar_lock.svg',
			'outlined/device/signal_wifi_2_bar.svg',
			'outlined/device/signal_wifi_2_bar_lock.svg',
			'outlined/device/signal_wifi_3_bar.svg',
			'outlined/device/signal_wifi_3_bar_lock.svg',
			'outlined/device/signal_wifi_4_bar.svg',
			'outlined/device/signal_wifi_4_bar_lock.svg',
			'outlined/device/signal_wifi_off.svg',
			'outlined/device/storage.svg',
			'outlined/device/usb.svg',
			'outlined/device/wallpaper.svg',
			'outlined/device/widgets.svg',
			'outlined/device/wifi_lock.svg',
			'outlined/device/wifi_tethering.svg',
			'outlined/editor/add_comment.svg',
			'outlined/editor/attach_file.svg',
			'outlined/editor/attach_money.svg',
			'outlined/editor/bar_chart.svg',
			'outlined/editor/border_all.svg',
			'outlined/editor/border_bottom.svg',
			'outlined/editor/border_clear.svg',
			'outlined/editor/border_color.svg',
			'outlined/editor/border_horizontal.svg',
			'outlined/editor/border_inner.svg',
			'outlined/editor/border_left.svg',
			'outlined/editor/border_outer.svg',
			'outlined/editor/border_right.svg',
			'outlined/editor/border_style.svg',
			'outlined/editor/border_top.svg',
			'outlined/editor/border_vertical.svg',
			'outlined/editor/bubble_chart.svg',
			'outlined/editor/drag_handle.svg',
			'outlined/editor/format_align_center.svg',
			'outlined/editor/format_align_justify.svg',
			'outlined/editor/format_align_left.svg',
			'outlined/editor/format_align_right.svg',
			'outlined/editor/format_bold.svg',
			'outlined/editor/format_clear.svg',
			'outlined/editor/format_color_fill.svg',
			'outlined/editor/format_color_reset.svg',
			'outlined/editor/format_color_text.svg',
			'outlined/editor/format_indent_decrease.svg',
			'outlined/editor/format_indent_increase.svg',
			'outlined/editor/format_italic.svg',
			'outlined/editor/format_line_spacing.svg',
			'outlined/editor/format_list_bulleted.svg',
			'outlined/editor/format_list_numbered.svg',
			'outlined/editor/format_list_numbered_rtl.svg',
			'outlined/editor/format_paint.svg',
			'outlined/editor/format_quote.svg',
			'outlined/editor/format_shapes.svg',
			'outlined/editor/format_size.svg',
			'outlined/editor/format_strikethrough.svg',
			'outlined/editor/format_textdirection_l_to_r.svg',
			'outlined/editor/format_textdirection_r_to_l.svg',
			'outlined/editor/format_underlined.svg',
			'outlined/editor/functions.svg',
			'outlined/editor/highlight.svg',
			'outlined/editor/insert_chart.svg',
			'outlined/editor/insert_chart_outlined.svg',
			'outlined/editor/insert_comment.svg',
			'outlined/editor/insert_drive_file.svg',
			'outlined/editor/insert_emoticon.svg',
			'outlined/editor/insert_invitation.svg',
			'outlined/editor/insert_link.svg',
			'outlined/editor/insert_photo.svg',
			'outlined/editor/linear_scale.svg',
			'outlined/editor/merge_type.svg',
			'outlined/editor/mode_comment.svg',
			'outlined/editor/monetization_on.svg',
			'outlined/editor/money_off.svg',
			'outlined/editor/multiline_chart.svg',
			'outlined/editor/notes.svg',
			'outlined/editor/pie_chart.svg',
			'outlined/editor/publish.svg',
			'outlined/editor/scatter_plot.svg',
			'outlined/editor/score.svg',
			'outlined/editor/short_text.svg',
			'outlined/editor/show_chart.svg',
			'outlined/editor/space_bar.svg',
			'outlined/editor/strikethrough_s.svg',
			'outlined/editor/table_chart.svg',
			'outlined/editor/text_fields.svg',
			'outlined/editor/title.svg',
			'outlined/editor/vertical_align_bottom.svg',
			'outlined/editor/vertical_align_center.svg',
			'outlined/editor/vertical_align_top.svg',
			'outlined/editor/wrap_text.svg',
			'outlined/fill/attachment.svg',
			'outlined/fill/cloud.svg',
			'outlined/fill/cloud_circle.svg',
			'outlined/fill/cloud_done.svg',
			'outlined/fill/cloud_download.svg',
			'outlined/fill/cloud_off.svg',
			'outlined/fill/cloud_queue.svg',
			'outlined/fill/cloud_upload.svg',
			'outlined/fill/create_new_folder.svg',
			'outlined/fill/folder.svg',
			'outlined/fill/folder_open.svg',
			'outlined/fill/folder_shared.svg',
			'outlined/hardware/cast.svg',
			'outlined/hardware/cast_connected.svg',
			'outlined/hardware/cast_for_education.svg',
			'outlined/hardware/computer.svg',
			'outlined/hardware/desktop_mac.svg',
			'outlined/hardware/desktop_windows.svg',
			'outlined/hardware/developer_board.svg',
			'outlined/hardware/devices_other.svg',
			'outlined/hardware/device_hub.svg',
			'outlined/hardware/device_unknown.svg',
			'outlined/hardware/dock.svg',
			'outlined/hardware/gamepad.svg',
			'outlined/hardware/headset.svg',
			'outlined/hardware/headset_mic.svg',
			'outlined/hardware/keyboard.svg',
			'outlined/hardware/keyboard_arrow_down.svg',
			'outlined/hardware/keyboard_arrow_left.svg',
			'outlined/hardware/keyboard_arrow_right.svg',
			'outlined/hardware/keyboard_arrow_up.svg',
			'outlined/hardware/keyboard_backspace.svg',
			'outlined/hardware/keyboard_capslock.svg',
			'outlined/hardware/keyboard_hide.svg',
			'outlined/hardware/keyboard_return.svg',
			'outlined/hardware/keyboard_tab.svg',
			'outlined/hardware/keyboard_voice.svg',
			'outlined/hardware/laptop.svg',
			'outlined/hardware/laptop_chromebook.svg',
			'outlined/hardware/laptop_mac.svg',
			'outlined/hardware/laptop_windows.svg',
			'outlined/hardware/memory.svg',
			'outlined/hardware/mouse.svg',
			'outlined/hardware/phonelink.svg',
			'outlined/hardware/phonelink_off.svg',
			'outlined/hardware/phone_android.svg',
			'outlined/hardware/phone_iphone.svg',
			'outlined/hardware/power_input.svg',
			'outlined/hardware/router.svg',
			'outlined/hardware/scanner.svg',
			'outlined/hardware/security.svg',
			'outlined/hardware/sim_card.svg',
			'outlined/hardware/smartphone.svg',
			'outlined/hardware/speaker.svg',
			'outlined/hardware/speaker_group.svg',
			'outlined/hardware/tablet.svg',
			'outlined/hardware/tablet_android.svg',
			'outlined/hardware/tablet_mac.svg',
			'outlined/hardware/toys.svg',
			'outlined/hardware/tv.svg',
			'outlined/hardware/videogame_asset.svg',
			'outlined/hardware/watch.svg',
			'outlined/image/add_a_photo.svg',
			'outlined/image/add_photo_alternate.svg',
			'outlined/image/add_to_photos.svg',
			'outlined/image/adjust.svg',
			'outlined/image/assistant.svg',
			'outlined/image/assistant_photo.svg',
			'outlined/image/audiotrack.svg',
			'outlined/image/blur_circular.svg',
			'outlined/image/blur_linear.svg',
			'outlined/image/blur_off.svg',
			'outlined/image/blur_on.svg',
			'outlined/image/brightness_1.svg',
			'outlined/image/brightness_2.svg',
			'outlined/image/brightness_3.svg',
			'outlined/image/brightness_4.svg',
			'outlined/image/brightness_5.svg',
			'outlined/image/brightness_6.svg',
			'outlined/image/brightness_7.svg',
			'outlined/image/broken_image.svg',
			'outlined/image/brush.svg',
			'outlined/image/burst_mode.svg',
			'outlined/image/camera.svg',
			'outlined/image/camera_alt.svg',
			'outlined/image/camera_front.svg',
			'outlined/image/camera_rear.svg',
			'outlined/image/camera_roll.svg',
			'outlined/image/center_focus_strong.svg',
			'outlined/image/center_focus_weak.svg',
			'outlined/image/collections.svg',
			'outlined/image/collections_bookmark.svg',
			'outlined/image/colorize.svg',
			'outlined/image/color_lens.svg',
			'outlined/image/compare.svg',
			'outlined/image/control_point.svg',
			'outlined/image/control_point_duplicate.svg',
			'outlined/image/crop.svg',
			'outlined/image/crop_16_9.svg',
			'outlined/image/crop_3_2.svg',
			'outlined/image/crop_5_4.svg',
			'outlined/image/crop_7_5.svg',
			'outlined/image/crop_din.svg',
			'outlined/image/crop_free.svg',
			'outlined/image/crop_landscape.svg',
			'outlined/image/crop_original.svg',
			'outlined/image/crop_portrait.svg',
			'outlined/image/crop_rotate.svg',
			'outlined/image/crop_square.svg',
			'outlined/image/details.svg',
			'outlined/image/edit.svg',
			'outlined/image/exposure.svg',
			'outlined/image/exposure_neg_1.svg',
			'outlined/image/exposure_neg_2.svg',
			'outlined/image/exposure_plus_1.svg',
			'outlined/image/exposure_plus_2.svg',
			'outlined/image/exposure_zero.svg',
			'outlined/image/filter.svg',
			'outlined/image/filter_1.svg',
			'outlined/image/filter_2.svg',
			'outlined/image/filter_3.svg',
			'outlined/image/filter_4.svg',
			'outlined/image/filter_5.svg',
			'outlined/image/filter_6.svg',
			'outlined/image/filter_7.svg',
			'outlined/image/filter_8.svg',
			'outlined/image/filter_9.svg',
			'outlined/image/filter_9_plus.svg',
			'outlined/image/filter_b_and_w.svg',
			'outlined/image/filter_center_focus.svg',
			'outlined/image/filter_drama.svg',
			'outlined/image/filter_frames.svg',
			'outlined/image/filter_hdr.svg',
			'outlined/image/filter_none.svg',
			'outlined/image/filter_tilt_shift.svg',
			'outlined/image/filter_vintage.svg',
			'outlined/image/flare.svg',
			'outlined/image/flash_auto.svg',
			'outlined/image/flash_off.svg',
			'outlined/image/flash_on.svg',
			'outlined/image/flip.svg',
			'outlined/image/gradient.svg',
			'outlined/image/grain.svg',
			'outlined/image/grid_off.svg',
			'outlined/image/grid_on.svg',
			'outlined/image/hdr_off.svg',
			'outlined/image/hdr_on.svg',
			'outlined/image/hdr_strong.svg',
			'outlined/image/hdr_weak.svg',
			'outlined/image/healing.svg',
			'outlined/image/image.svg',
			'outlined/image/image_aspect_ratio.svg',
			'outlined/image/image_search.svg',
			'outlined/image/iso.svg',
			'outlined/image/landscape.svg',
			'outlined/image/leak_add.svg',
			'outlined/image/leak_remove.svg',
			'outlined/image/lens.svg',
			'outlined/image/linked_camera.svg',
			'outlined/image/looks.svg',
			'outlined/image/looks_3.svg',
			'outlined/image/looks_4.svg',
			'outlined/image/looks_5.svg',
			'outlined/image/looks_6.svg',
			'outlined/image/looks_one.svg',
			'outlined/image/looks_two.svg',
			'outlined/image/loupe.svg',
			'outlined/image/monochrome_photos.svg',
			'outlined/image/movie_creation.svg',
			'outlined/image/movie_filter.svg',
			'outlined/image/music_note.svg',
			'outlined/image/music_off.svg',
			'outlined/image/nature.svg',
			'outlined/image/nature_people.svg',
			'outlined/image/navigate_before.svg',
			'outlined/image/navigate_next.svg',
			'outlined/image/palette.svg',
			'outlined/image/panorama.svg',
			'outlined/image/panorama_fish_eye.svg',
			'outlined/image/panorama_horizontal.svg',
			'outlined/image/panorama_vertical.svg',
			'outlined/image/panorama_wide_angle.svg',
			'outlined/image/photo.svg',
			'outlined/image/photo_album.svg',
			'outlined/image/photo_camera.svg',
			'outlined/image/photo_filter.svg',
			'outlined/image/photo_library.svg',
			'outlined/image/photo_size_select_actual.svg',
			'outlined/image/photo_size_select_large.svg',
			'outlined/image/photo_size_select_small.svg',
			'outlined/image/picture_as_pdf.svg',
			'outlined/image/portrait.svg',
			'outlined/image/remove_red_eye.svg',
			'outlined/image/rotate_90_degrees_ccw.svg',
			'outlined/image/rotate_left.svg',
			'outlined/image/rotate_right.svg',
			'outlined/image/shutter_speed.svg',
			'outlined/image/slideshow.svg',
			'outlined/image/straighten.svg',
			'outlined/image/style.svg',
			'outlined/image/switch_camera.svg',
			'outlined/image/switch_video.svg',
			'outlined/image/tag_faces.svg',
			'outlined/image/texture.svg',
			'outlined/image/timelapse.svg',
			'outlined/image/timer.svg',
			'outlined/image/timer_10.svg',
			'outlined/image/timer_3.svg',
			'outlined/image/timer_off.svg',
			'outlined/image/tonality.svg',
			'outlined/image/transform.svg',
			'outlined/image/tune.svg',
			'outlined/image/view_comfy.svg',
			'outlined/image/view_compact.svg',
			'outlined/image/vignette.svg',
			'outlined/image/wb_auto.svg',
			'outlined/image/wb_cloudy.svg',
			'outlined/image/wb_incandescent.svg',
			'outlined/image/wb_iridescent.svg',
			'outlined/image/wb_sunny.svg',
			'outlined/maps/directions_railway.svg',
			'outlined/maps/directions_run.svg',
			'outlined/maps/directions_subway.svg',
			'outlined/maps/directions_transit.svg',
			'outlined/maps/directions_walk.svg',
			'outlined/maps/edit_attributes.svg',
			'outlined/maps/edit_location.svg',
			'outlined/maps/ev_station.svg',
			'outlined/maps/fastfood.svg',
			'outlined/maps/flight.svg',
			'outlined/maps/hotel.svg',
			'outlined/maps/layers.svg',
			'outlined/maps/layers_clear.svg',
			'outlined/maps/local_activity.svg',
			'outlined/maps/local_airport.svg',
			'outlined/maps/local_atm.svg',
			'outlined/maps/local_bar.svg',
			'outlined/maps/local_cafe.svg',
			'outlined/maps/local_car_wash.svg',
			'outlined/maps/local_convenience_store.svg',
			'outlined/maps/local_dining.svg',
			'outlined/maps/local_drink.svg',
			'outlined/maps/local_florist.svg',
			'outlined/maps/local_gas_station.svg',
			'outlined/maps/local_grocery_store.svg',
			'outlined/maps/local_hospital.svg',
			'outlined/maps/local_hotel.svg',
			'outlined/maps/local_laundry_service.svg',
			'outlined/maps/local_library.svg',
			'outlined/maps/local_mall.svg',
			'outlined/maps/local_movies.svg',
			'outlined/maps/local_offer.svg',
			'outlined/maps/local_parking.svg',
			'outlined/maps/local_pharmacy.svg',
			'outlined/maps/local_phone.svg',
			'outlined/maps/local_pizza.svg',
			'outlined/maps/local_play.svg',
			'outlined/maps/local_post_office.svg',
			'outlined/maps/local_printshop.svg',
			'outlined/maps/local_see.svg',
			'outlined/maps/local_shipping.svg',
			'outlined/maps/local_taxi.svg',
			'outlined/maps/map.svg',
			'outlined/maps/money.svg',
			'outlined/maps/my_location.svg',
			'outlined/maps/navigation.svg',
			'outlined/maps/near_me.svg',
			'outlined/maps/not_listed_location.svg',
			'outlined/maps/person_pin.svg',
			'outlined/maps/person_pin_circle.svg',
			'outlined/maps/pin_drop.svg',
			'outlined/maps/place.svg',
			'outlined/maps/rate_review.svg',
			'outlined/maps/restaurant.svg',
			'outlined/maps/restaurant_menu.svg',
			'outlined/maps/satellite.svg',
			'outlined/maps/store_mall_directory.svg',
			'outlined/maps/streetview.svg',
			'outlined/maps/subway.svg',
			'outlined/maps/terrain.svg',
			'outlined/maps/traffic.svg',
			'outlined/maps/train.svg',
			'outlined/maps/tram.svg',
			'outlined/maps/transfer_within_a_station.svg',
			'outlined/maps/transit_enterexit.svg',
			'outlined/maps/trip_origin.svg',
			'outlined/maps/zoom_out_map.svg',
			'outlined/navigation/apps.svg',
			'outlined/navigation/arrow_back.svg',
			'outlined/navigation/arrow_back_ios.svg',
			'outlined/navigation/arrow_downward.svg',
			'outlined/navigation/arrow_drop_down.svg',
			'outlined/navigation/arrow_drop_down_circle.svg',
			'outlined/navigation/arrow_drop_up.svg',
			'outlined/navigation/arrow_forward.svg',
			'outlined/navigation/arrow_forward_ios.svg',
			'outlined/navigation/arrow_left.svg',
			'outlined/navigation/arrow_right.svg',
			'outlined/navigation/arrow_upward.svg',
			'outlined/navigation/cancel.svg',
			'outlined/navigation/check.svg',
			'outlined/navigation/chevron_left.svg',
			'outlined/navigation/chevron_right.svg',
			'outlined/navigation/close.svg',
			'outlined/navigation/expand_less.svg',
			'outlined/navigation/expand_more.svg',
			'outlined/navigation/first_page.svg',
			'outlined/navigation/fullscreen.svg',
			'outlined/navigation/fullscreen_exit.svg',
			'outlined/navigation/last_page.svg',
			'outlined/navigation/menu.svg',
			'outlined/navigation/more_horiz.svg',
			'outlined/navigation/more_vert.svg',
			'outlined/navigation/refresh.svg',
			'outlined/navigation/subdirectory_arrow_left.svg',
			'outlined/navigation/subdirectory_arrow_right.svg',
			'outlined/navigation/unfold_less.svg',
			'outlined/navigation/unfold_more.svg',
			'outlined/notification/adb.svg',
			'outlined/notification/airline_seat_flat.svg',
			'outlined/notification/airline_seat_flat_angled.svg',
			'outlined/notification/airline_seat_individual_suite.svg',
			'outlined/notification/airline_seat_legroom_extra.svg',
			'outlined/notification/airline_seat_legroom_normal.svg',
			'outlined/notification/airline_seat_legroom_reduced.svg',
			'outlined/notification/airline_seat_recline_extra.svg',
			'outlined/notification/airline_seat_recline_normal.svg',
			'outlined/notification/bluetooth_audio.svg',
			'outlined/notification/confirmation_number.svg',
			'outlined/notification/disc_full.svg',
			'outlined/notification/drive_eta.svg',
			'outlined/notification/enhanced_encryption.svg',
			'outlined/notification/event_available.svg',
			'outlined/notification/event_busy.svg',
			'outlined/notification/event_note.svg',
			'outlined/notification/folder_special.svg',
			'outlined/notification/live_tv.svg',
			'outlined/notification/mms.svg',
			'outlined/notification/more.svg',
			'outlined/notification/network_check.svg',
			'outlined/notification/network_locked.svg',
			'outlined/notification/no_encryption.svg',
			'outlined/notification/ondemand_video.svg',
			'outlined/notification/personal_video.svg',
			'outlined/notification/phone_bluetooth_speaker.svg',
			'outlined/notification/phone_callback.svg',
			'outlined/notification/phone_forwarded.svg',
			'outlined/notification/phone_in_talk.svg',
			'outlined/notification/phone_locked.svg',
			'outlined/notification/phone_missed.svg',
			'outlined/notification/phone_paused.svg',
			'outlined/notification/power.svg',
			'outlined/notification/power_off.svg',
			'outlined/notification/priority_high.svg',
			'outlined/notification/sd_card.svg',
			'outlined/notification/sms.svg',
			'outlined/notification/sms_failed.svg',
			'outlined/notification/sync.svg',
			'outlined/notification/sync_disabled.svg',
			'outlined/notification/sync_problem.svg',
			'outlined/notification/system_update.svg',
			'outlined/notification/tap_and_play.svg',
			'outlined/notification/time_to_leave.svg',
			'outlined/notification/tv_off.svg',
			'outlined/notification/vibration.svg',
			'outlined/notification/voice_chat.svg',
			'outlined/notification/vpn_lock.svg',
			'outlined/notification/wc.svg',
			'outlined/notification/wifi.svg',
			'outlined/notification/wifi_off.svg',
			'outlined/places/ac_unit.svg',
			'outlined/places/airport_shuttle.svg',
			'outlined/places/all_inclusive.svg',
			'outlined/places/beach_access.svg',
			'outlined/places/business_center.svg',
			'outlined/places/casino.svg',
			'outlined/places/child_care.svg',
			'outlined/places/child_friendly.svg',
			'outlined/places/fitness_center.svg',
			'outlined/places/free_breakfast.svg',
			'outlined/places/golf_course.svg',
			'outlined/places/hot_tub.svg',
			'outlined/places/kitchen.svg',
			'outlined/places/meeting_room.svg',
			'outlined/places/no_meeting_room.svg',
			'outlined/places/pool.svg',
			'outlined/places/room_service.svg',
			'outlined/places/rv_hookup.svg',
			'outlined/places/smoke_free.svg',
			'outlined/places/smoking_rooms.svg',
			'outlined/places/spa.svg',
			'outlined/social/cake.svg',
			'outlined/social/domain.svg',
			'outlined/social/group.svg',
			'outlined/social/group_add.svg',
			'outlined/social/location_city.svg',
			'outlined/social/mood.svg',
			'outlined/social/mood_bad.svg',
			'outlined/social/notifications.svg',
			'outlined/social/notifications_active.svg',
			'outlined/social/notifications_none.svg',
			'outlined/social/notifications_off.svg',
			'outlined/social/notifications_paused.svg',
			'outlined/social/pages.svg',
			'outlined/social/party_mode.svg',
			'outlined/social/people.svg',
			'outlined/social/people_outline.svg',
			'outlined/social/person.svg',
			'outlined/social/person_add.svg',
			'outlined/social/person_outline.svg',
			'outlined/social/plus_one.svg',
			'outlined/social/poll.svg',
			'outlined/social/public.svg',
			'outlined/social/school.svg',
			'outlined/social/sentiment_dissatisfied.svg',
			'outlined/social/sentiment_satisfied.svg',
			'outlined/social/sentiment_very_dissatisfied.svg',
			'outlined/social/sentiment_very_satisfied.svg',
			'outlined/social/share.svg',
			'outlined/social/thumb_down_alt.svg',
			'outlined/social/thumb_up_alt.svg',
			'outlined/social/whatshot.svg',
			'outlined/toggle/check_box.svg',
			'outlined/toggle/check_box_outline_blank.svg',
			'outlined/toggle/indeterminate_check_box.svg',
			'outlined/toggle/radio_button_checked.svg',
			'outlined/toggle/radio_button_unchecked.svg',
			'outlined/toggle/star.svg',
			'outlined/toggle/star_border.svg',
			'outlined/toggle/star_half.svg',
			'outlined/toggle/toggle_off.svg',
			'outlined/toggle/toggle_on.svg'
		]
	}
];
const ChineseIconCategory = [
	['action', 'å¨ä½ç±»'],
	['alert', 'è­¦ç¤ºç±»'],
	['av', 'é³è§é¢ç±»'],
	['communication', 'éä¿¡ç±»'],
	['content', 'åå®¹ç±»'],
	['device', 'è£ç½®ç±»'],
	['editor', 'ç¼è¾ç±»'],
	['fill', 'å¡«åç±»'],
	['hardware', 'ç¡¬ä»¶ç±»'],
	['image', 'å½¢è±¡ç±»'],
	['maps', 'ç±»'],
	['navigation', 'å¯¼èªç±»'],
	['notification', 'åç¤ºç±»'],
	['places', 'ä½ç½®ç±»'],
	['social', 'ç¤¾ä¼'],
	['toggle', 'å¼å³']
];
export class IconCategory {
	category: string;
	categoryCN: string;
	icons: Icon[];
}
class Icon {
	name: string;
	fs: string;
	constructor(data: { name: string; fs: string }) {
		this.name = data.name;
		this.fs = data.fs;
	}
}
@Injectable({
	providedIn: 'root'
})
export class IconList {
	icons: { [nameSpace: string]: IconCategory[] } = {};
	constructor() {
		iconList.forEach(v => {
			const groupCategory: { [key: string]: IconCategory } = {};
			const categoryOrder: IconCategory[] = [];
			v.list.forEach(vv => {
				const key = vv.split(/(\\|\/)/g)[2];
				if (!groupCategory[key]) {
					const c = new IconCategory();
					c.category = key;
					const findArr = ChineseIconCategory.find(cnArr => cnArr[0] === key);
					if (findArr) {
						c.categoryCN = findArr[1];
					} else {
						c.categoryCN = c.category;
					}
					c.icons = [new Icon({ name: withoutExt(vv), fs: vv })];
					groupCategory[key] = c;
					categoryOrder.push(c);
				} else {
					groupCategory[key].icons.push(new Icon({ name: withoutExt(vv), fs: vv }));
				}
			});
			this.icons[v.nameSpace] = categoryOrder;
		});
	}
}
function withoutExt(fsName: string): string {
	return fsName
		.split(/(\\|\/)/g)
		.pop()
		.split('.')[0];
}
